import { post, globalPut } from '../index';

export const addNewIdea = (idea) => {
    return post('/ideas', idea, false);
};

export const updateIdea = (idea) => {
    return globalPut('/ideas', idea, false);
};
